import { render, staticRenderFns } from "./ProgramSelection.vue?vue&type=template&id=3b0e0a8d&scoped=true&"
import script from "./ProgramSelection.vue?vue&type=script&lang=js&"
export * from "./ProgramSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e0a8d",
  null
  
)

export default component.exports